import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import './Login.css';

const Login = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginWithMsal } = useAuth();

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Customer Portal</h1>
          <p>Please sign in to continue</p>
        </div>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        
        <div className="login-form">
          <button 
            type="button" 
            className="login-button" 
            onClick={async () => {
              setError('');
              setLoading(true);
              const result = await loginWithMsal();
              if (!result.success) {
                setError(result.error);
              }
              setLoading(false);
            }}
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign in with Microsoft'}
          </button>
        </div>
        
        <div className="login-footer">
          <p>Need help? Contact your administrator</p>
        </div>
      </div>
    </div>
  );
};

export default Login;

